import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  { 
    path: "/", 
    name: "home", 
    component: () => import("@/presentation/Home/Home.vue"), 
    meta: { requiresAuth: false }
  },

  {
    path: "/weekly-outings",
    name: "weekly-outings",
    component: () => import("@/presentation/Outings/Outings.vue"),
    meta: { requiresAuth: false }
  },

  {
    path: "/registration",
    name: "registration",
    component: () => import("@/presentation/Register/Registration.vue"),
    meta: { requiresAuth: false }
  },

  {
    path: "/register",
    redirect: "/registration"
  },

  {
    path: "/careers",
    name: "careers",
    component: () => import("@/presentation/Careers/CareersPage.vue"),
    meta: { requiresAuth: false }
  },

  {
    path: "/careers/:id",
    name: "job-details",
    component: () => import("@/presentation/Careers/JobDetailsPage.vue"),
    meta: { requiresAuth: false }
  },

  {
    path: "/cdr-got-talent",
    name: "talent",
    component: () => import("@/presentation/Talent/TalentPage.vue"),
    meta: { requiresAuth: false }
  },

  {
    path: "/talent/confirm",
    name: "talent-confirm",
    component: () => import("@/presentation/Talent/TalentConfirmPage.vue"),
    meta: { requiresAuth: false }
  },

  {
    path: "/dunk-and-kick",
    name: "academy",
    component: () => import("@/presentation/Academy/AcademyPage.vue"),
    meta: { requiresAuth: false }
  },

  {
    path: "/nerd-smart-afternoons",
    name: "nerd",
    component: () => import("@/presentation/Nerd/NerdPage.vue"),
    meta: { requiresAuth: false }
  },

]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // Return to previous scroll position
    } else {
      return { top: 0 }; // Scroll to the top of the page
    }
  }
})


export default router
